import { useAtom } from "jotai";
import "../../css/terms.css";
import { headerText } from "../../App";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
const TermsOfUse = () => {
  const location = useLocation();

  const [headerTextAtom, setHeaderTextAtom] = useAtom(headerText);

  useEffect(() => {
    setHeaderTextAtom("이용안내");
  }, [location?.state]);
  return (
    <>
      <div className="container container-terms">
        <h1 className="terms_heading_main">탑탑 이용약관</h1>
        <p>
          (주)어셈브릭스의 “탑탑” 웹사이트의 이용과 관련 한 제반 서비스의 이용에 대한 필요한 사항을 규정합니다.{" "}
        </p>
        <h6 className="terms_sub_heading">제1조 ( 목 적 )</h6>
        <p>
        이 약관은 (주)어셈브릭스가 운영하는 탑탑 웹사이트(http://www.top-top.kr, 이하 “탑탑”라 한다)에서 
        제공하는 인터넷 관련 서비스 및 기타 부대서비스의 이용조건 및 절차에 관한 기본적인 사항을 정함을 목적으로 합니다.{" "}
        </p>

        <h6 className="terms_sub_heading">제2조 ( 정 의 )</h6>
        <p>
        이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
          <ul>
            <li>
              ① "탑탑"란 (주)어셈브릭스가 운영하는 온라인사이트(http://www.top-top.kr)로서 화물자동차 운송사업 및 운송주선사업 허가증(이하 “운송사업허가증”) 매매 관련 정보의 게시 또는 열람(이하 “온라인서비스) 및 
              “운송사업허가증”의 양도·양수 중개 및 행정업무 대행(이하 “중개서비스”)과 관련 제반 상품 서비스를 제공하는 사이트를 의미합니다.
            </li>
            <li>
              ② "서비스"라 함은 구현되는 단말기(PC, 휴대형 단말기 등의 각종 유무선 장치)와 상관 없이 “이용자”가 이용할 수 있는 "탑탑"이 제공하는 재화의 공급 및 용역이행을 말합니다.{" "}
            </li>
            <li>
              ③ "이용자"란 "탑탑"에 접속하여 이 약관에 따라 “탑탑”이 제공하는 서비스를 받는 회원 및 비회원을 말합니다.
            </li>
            <li>
              ④ "회원"이라 함은 "탑탑"에 개인정보를 제공하여 회원등록을 한 자로서, "탑탑"의 정보를 지속적으로 제공받으며, “탑탑”이 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다.{" "}
            </li>
            <li>⑤ "비회원"이라 함은 회원에 가입하지 않고 “탑탑”이 제공하는 서비스를 이용하는 자를 말합니다.</li>
            <li>⑥ "쿠폰"이라 함은 회원에게 “탑탑”에서 제공되는 유료 “서비스” 결제 시 일정금액 또는 일정비율을 할인 받을 수 있는 사이버 쿠폰을 말합니다.</li>
            <li>
              ⑦ “포인트”라 함은 회원이 “탑탑”에서 제공되는 유료 “서비스” 결제 시 현금처럼 사용할 수 있는 회사 전용의 사이버 화폐를 말합니다.{" "}
            </li>
            <li>
              ⑧ “매물”이라 함은 회원 혹은 “탑탑”이 삽니다 혹은 팝니다 메뉴에 등록한 화물운송사업허가증 및 운송주선사업허가증 등 매매하고자 게시 한 정보를 말합니다.
            </li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">
          제3조 ( 약관의 명시와 개정 )
        </h6>
        <p>
          <ul>
            <li>
              ① (주)어셈브릭스는 “탑탑” 약관의 내용과 상호, 영업소 소재지, 대표자의 성명, 연락처(전화, 팩스, 전자우편 주소 등) 등을 이용자가 알 수 있도록 탑탑의 초기화면에 게시합니다.
            </li>
            <li>
              ② (주)어셈브릭스는 “약관의규제에관한법률”, “전자거래기본법”, “전자서명법”, “정보통신망이용촉진등에관한법률”, “방문판매등에관한법률”, “소비자보호법” 등 관련법을 위배하지 않는 범위에서 약관을 개정할 수 있습니다.{" "}
            </li>
            <li>
              ③ (주)어셈브릭스가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 탑탑의 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다. 다만, 회원에게 불리한 약관 개정의 경우 공지 외에 일정기간 서비스내 전자우편, 전자쪽지, 로그인시 동의창 등의 전자적 수단을 통해 따로 명확히 통지하도록 합니다.
            </li>
            <li>
              ④ (주)어셈브릭스 전항에 따라 개정약관을 공지 또는 통지하면서 회원에게 7일 기간 내에 의사표시를 하지 않으면 의사표시가 표명된 것으로 본다는 뜻을 명확하게 공지 또는 통지하였음에도 회원이 명시적으로 거부의 의사표시를 하지 아니한 경우 회원이 개정약관에 동의한 것으로 봅니다.
            </li>
            <li>
              ⑤ (주)어셈브릭스는 회원이 개정약관의 적용에 동의하지 않는 경우 개정 약관의 내용을 적용할 수 없으며, 이 경우 회원은 이용계약을 해지할 수 있습니다. 다만, 기존 약관을 적용할 수 없는 특별한 사정이 있는 경우에는 (주)어셈브릭스는 이용계약을 해지할 수 있습니다.
            </li>
            <li>
              ⑥ 이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 정부가 제정한 “전자거래소비자보호지침” 및 관계법령 또는 상관례에 따릅니다.
            </li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">제4조 ( 서비스 이용계약의 성립 )</h6>
        <p>
          <ul>
            <li>
              ① 서비스 이용계약은 회원이 되고자 하는 자가 본 이용약관에 동의하고, 가입신청 절차에 따라 회원가입신청을 하고 (주)어셈브릭스가 이러한 신청에 대하여 승낙함으로써 성립됩니다.
            </li>
            <li>
              ② (주)어셈브릭스는 가입신청자의 신청에 대하여 서비스 이용을 승낙함을 원칙으로 합니다. 다만, (주)어셈브릭스는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.
              <ol>
                <li>가입신청자가 이 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우, 단 (주)어셈브릭스가 회원 재가입 승낙을 한 경우에는 예외로 함</li>
                <li>신청 내용에 허위, 기재누락, 오기가 있는 경우</li>
                <li>이용자의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우</li>
              </ol>
            </li>
            <li>
              ③ (주)어셈브릭스는 가입신청자의 신청에 대하여 서비스 이용을 승낙함을 원칙으로 합니다. 다만, (주)어셈브릭스는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.
            </li>
            <li>
              ④ (주)어셈브릭스는 제1항에 따른 신청에 있어 회원가입신청자에 대한 실명확인 및 본인 인증 요청을 할 수 있습니다.
            </li>
            <li>
              ⑤ (주)어셈브릭스는 서비스관련설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우 회원가입승낙을 유보할 수 있습니다.
            </li>
            <li>
              ⑥ (주)어셈브릭스는제2항과 제4항에 따라 회원가입신청의 승낙을 하지 아니하거나 유보한 경우, 원칙적으로 이를 가입신청자에게 거나 유보한 경우, 원칙적으로 이를 가입신청자에게 알리도록 합니다.
            </li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">제5조 ( 회원가입 및 정보의 변경 )</h6>
        <p>
          <ul>
            <li>
              ① 이용자는 “탑탑”이 정한 가입양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다.
            </li>
            <li>
              ② 이용자가 다음 각호의 사유가 있는 경우에는 회원가입이 제한될 수 있습니다.
              <ol>
                <li>
                  제6조 1항에 의거 회원 탈퇴한 경우 탈퇴일로부터 1개월 이내
                </li>
                <li>가입신청자가 이 약관 제6조 3항에 의하여 이전에 회원자격을 상실한 적이 있는 경우, 다만 제6조 3항에 의한 회원자격 상실 후 3년이 경과한 자로서 “탑탑”의 회원재가입 승낙을 얻은 경우에는 예외로 한다.</li>
                <li>
                  등록 내용에 허위, 기재누락, 오기가 있는 경우
                </li>
                <li>기타 회원으로 등록하는 것이 “탑탑”의 기술상 현저히 지장이 있다고 판단되는 경우</li>
                <li>회원의 나이가 만 14세 미만일 경우</li>
              </ol>
            </li>
            <li>
              ③ 회원가입계약의 성립시기는 “탑탑”의 승낙이 회원에게 도달한 시점으로 합니다..
            </li>
            <li>
              ④ 회원은 제8조 1항에 의한 등록사항에 변경이 있는 경우, 즉시 전자우편 또는 기타 방법으로 “탑탑”에 대하여 그 변경사항을 알려야 합니다.
            </li>
            <li>	
              ⑤ 회원은 개인정보관리화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 실명, 주민등록번호, 아이디 등은 수정이 불가능합니다.</li>
            <li>
              ⑥ 회원은 회원가입신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정하거나 전자우편 기타 방법으로 (주)어셈브릭스에 그 변경사항을 알려야 합니다.
            </li>
            <li>
              ⑦ 회원이 제6항의 변경사항을 알리지 않아 발생한 불이익에 대하여 (주)어셈브릭스에게 귀책사유가 있는 부분을 제외하고는 회원이 책임을 부담합니다.
            </li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">제6조 ( 회원 탈퇴 및 자격상실 ) </h6>
        <p>
          <ul>
            <li>
              ① 회원은 언제든지 (주)어셈브릭스에 회원 탈퇴를 요청할 수 있으며, (주)어셈브릭스는 즉시 회원탈퇴를 처리합니다.
            </li>
            <li>
              ② (주)어셈브릭스는 회원이 다음 각호의 사유에 해당하는 경우, 회원자격을 제한 및 정지시킬 수 있습니다.
              <ol>
                <li>
                  가입 신청시에 허위 내용을 등록한 경우
                </li>
                <li>다른 사람의 서비스이용을 방해하거나 그 정보를 도용하는 등 전자거래질서를 위협하는 경우</li>
                <li>
                  서비스 이용 중 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우
                </li>
                <li>
                  등록매물에 대하여 보복성 허위 신고를 하거나 허위 신고 행위가 반복되는 경우
                </li>
              </ol>
            </li>
            <li>
              ③ (주)어셈브릭스가 회원 자격을 제한 또는 정지 시킨 후, 동일한 행위가 2회이상 반복되거나 30일이내에 그 사유가 시정되지 아니하는 경우 (주)어셈브릭스는 회원자격을 상실시킬 수 있습니다.
            </li>
            <li>
              ④ (주)어셈브릭스가 회원자격을 상실시키는 경우에는 회원등록을 말소합니다. 이 경우 회원에게 이를 통지하고, 회원등록 말소 전에 소명할 기회를 부여합니다.
            </li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">제7조 ( 회원에 대한 통지 )</h6>
        <p>
          <ul>
            <li>
              ① (주)어셈브릭스가 회원에 대한 통지를 하는 경우, 회원이 회원가입 시 기재한 전자우편 주소로 할 수 있습니다.
            </li>
            <li>
              ② (주)어셈브릭스는 회원 전체에 대한 통지의 경우 7일 이상 탑탑 웹사이트(http://www.top-top.kr)의 편의(공지사항)란에 게시함으로써 제1항의 통지에 갈음할 수 있습니다.
            </li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">제8조 ( 개인정보보호 ) </h6>
        <p>
          <ul>
            <li>
              ① (주)어셈브릭스는 이용자의 정보수집 시 구매계약 이행에 필요한 최소한의 정보를 수집합니다. 다음 사항을 필수사항으로 하며 그 외 사항은 선택사항으로 합니다. 
              1. 성명 2. 실명확인값 3.i-pin번호 4. 전자우편주소 5. 희망ID 6. 비밀번호 7. 사용자 구분(개인, 법인)
              {/* <ol>
                <li>성명</li>
                <li>실명확인값</li>
                <li>i-pin번호</li>
                <li>전자우편주소</li>
                <li>희망ID</li>
                <li>비밀번호</li>
                <li>사용자 구분(개인, 법인)</li>
              </ol> */}
            </li>
            <li>
              ② (주)어셈브릭스는 이용자의 개인식별이 가능한 개인정보를 수집한 때에는 반드시 당해 이용자의 동의를 받습니다.
            </li>
            <li>
              ③ 제공된 개인정보는 당해 이용자의 동의 없이 목적 외의 이용이나 제3자에게 제공할 수 없으며, 이에 대한 모든 책임은 (주)어셈브릭스가 집니다. 다만, 다음의 경우에는 예외로 합니다.
              <ol>
                <li>
                  서비스이행을 위해 제휴서비스 제공에 필요한 최소한의 이용자의 정보를 제휴업체에 알려주는 경우
                </li>
                <li>통계작성, 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 식별할 수 없는 형태로 제공하는 경우</li>
                <li>
                  관계법령에 의한 경우
                </li>
              </ol>
            </li>
            <li>
              ④ (주)어셈브릭스는 제2항과 제3항에 의해 이용자의 동의를 받아야 하는 경우에는 개인정보관리책임자의 신원(소속, 성명 및 전화번호 기타 연락처), 정보의 수집목적 및 이용목적, 제3자에 대한 정보제공 관련사항(제공받는자, 제공목적 및 제공할 정보의 내용)등 “정보통신망이용촉진등에관한법률” 제16조 3항이 규정한 사항을 미리 명시하거나 고지해야 하며 이용자는 언제든지 이 동의를 철회할 수 있습니다.
            </li>
            <li>
              ⑤ 이용자는 언제든지 (주)어셈브릭스가 가지고 있는 자신의 개인정보에 대해 열람 및 오류정정을 요구할 수 있으며 (주)어셈브릭스는 이에 대해 지체 없이 필요한 조치를 취할 의무를 집니다. 이용자가 오류의 정정을 요구한 경우에는 (주)어셈브릭스는 그 오류를 정정할 때까지 당해 개인정보를 이용하지 않습니다.
            </li>
            <li>
              ⑥ (주)어셈브릭스는 개인정보 보호를 위하여 관리자를 한정하여 그 수를 최소화하며 신용카드, 은행계좌 등을 포함한 이용자의 개인정보의 분실, 도난, 유출, 변조 등으로 인한 이용자의 손해를 방지하기 위해 최선의 노력을 다합니다.
            </li>
            <li>
              ⑦ (주)어셈브릭스 또는 그로부터 개인정보를 제공받은 제3자는 개인정보의 수집목적 또는 제공받은 목적을 달성한 때에는 당해 개인정보를 지체 없이 파기합니다.
            </li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">제9조 ( 회원의 아이디 및 비밀번호 관리에 대한 의무 ) </h6>
        <p>
          <ul>
            <li>
              ① 회원의 "아이디"와 "비밀번호"에 관한 관리책임은 회원에게 있으며, 이를 제3자가 이용하도록 하여서는 안 됩니다.
            </li>
            <li>
              ② (주)어셈브릭스는 회원의 "아이디"가 개인정보 유출 우려가 있거나, 반사회적 또는 미풍양속에 어긋나거나 (주)어셈브릭스 및 (주)어셈브릭스의 운영자로 오인한 우려가 있는 경우, 해당 "아이디"의 이용을 제한할 수 있습니다.
            </li>
            <li>
              ③ 회원은 "아이디" 및 "비밀번호"가 도용되거나 제3자가 사용하고 있음을 인지한 경우에는 이를 즉시 (주)어셈브릭스에 통지하고 (주)어셈브릭스의 안내에 따라야 합니다.
            </li>
            <li>
              ④ 제3항의 경우에 해당 회원이 (주)어셈브릭스에 그 사실을 통지하지 않거나, 통지한 경우에도 (주)어셈브릭스의 안내에 따르지 않아 발생한 불이익에 대하여 (주)어셈브릭스는 책임지지 않습니다. 다만 (주)어셈브릭스의 귀책사유가 경합하여 그러한 불이익이 발생한 경우에는 관계법령에 따라 책임을 부담합니다.
            </li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">제10조 ( (주)어셈브릭스의 의무 ) </h6>
        <p>
          <ul>
            <li>
              ① (주)어셈브릭스는 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고, 안정적으로 서비스를 제공하는 데 최선을 다하여 노력합니다.
            </li>
            <li>
              ② (주)어셈브릭스는 이용자가 안전하게 인터넷 서비스를 이용할 수 있도록 이용자의 개인정보(신용정보 포함) 보호를 위한 보안 시스템을 갖추어야 합니다.
            </li>
            <li>
              ③ (주)어셈브릭스는 서비스이용과 관련하여 발생하는 이용자의 불만 또는 피해구제요청을 적절하게 처리할 수 있도록 필요한 인력 및 시스템을 구비합니다.
            </li>
            <li>
              ④ (주)어셈브릭스는 서비스이용과 관련하여 회원으로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를 처리하여야 합니다. 회원이 제기한 의견이나 불만사항에 대해서는 게시판을 활용하거나 전자우편 등을 통하여 회원에게 처리과정 및 결과를 전달합니다.
            </li>
            <li>
              ⑤ (주)어셈브릭스는 이용자가 원하지 않는 영리목적의 광고성 전자우편을 발송하지 않습니다.
            </li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">제11조 ( 이용자의 의무 )</h6>
        <p>
          <ul>
            <li>
              ① 이용자는 다음 행위를 하여서는 안되며, 이에 대한 법률적인 책임은 이용자에게 있습니다.
              <ol>
                <li>신청 또는 변경시 허위내용의 등록</li>
                <li>(주)어셈브릭스에 게시된 정보의 변경</li>
                <li>(주)어셈브릭스가 정한 정보 이외의 정보(컴퓨터 프로그램 등)를 송신 또는 게시</li>
                <li>(주)어셈브릭스의 서비스를 이용하여 얻은 정보를 승낙 없이 복제 유통하거나 상업적으로 이용하는 행위</li>
                <li>(주)어셈브릭스 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
                <li>(주)어셈브릭스 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
                <li>외설 또는 폭력적인 메시지,화상,음성 기타 공서양속에 반하는 정보를 “탑탑”에 공개 또는 게시하는 행위</li>
                <li>서비스와 관련된 설비의 오작동이나 정보 등의 파괴와 혼란을 유발하는 컴퓨터 바이러스 감염자료를 등록하거나 유포하는 행위</li>
                <li>(주)어셈브릭스의 직원이나 운영자로 가장 또는 속이거나 타인의 명의를 무단으로 사용하여 글을 게시하거나 이메일을 발송하는 행위</li>
                <li>기타 불법적이거나 부당한 행위</li>
              </ol>
            </li>
            <li>
              ② 회원은 관계법, 이 약관의 규정, 이용안내 및 "서비스"와 관련하여 공지한 주의사항, (주)어셈브릭스가 통지하는 사항 등을 준수하여야 하며, 기타 (주)어셈브릭스의 업무에 방해되는 행위를 하여서는 안 됩니다.
            </li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">제12조 ( 서비스의 제공 및 변경 ) </h6>
        <p>
          <ul>
            <li>
              ① (주)어셈브릭스는 “탑탑”을 통해 다음과 같은 업무를 수행합니다.
              <ol>
                <li>화물자동차 운송사업 및 운송주선사업 허가증 시세 정보</li>
                <li>화물자동차 운송사업 및 운송주선사업 허가증 매매 및 중개관련 정보제공</li>
                <li>이용자의 자동차 매매 및 중개과정에서 발생할 수 있는 금융 및 보험관련 정보의 제공</li>
                <li>기타 (주)어셈브릭스가 추가 개발하거나 다른 회사와의 제휴 계약 등을 통해 이용자에게 제공하는 일체의 서비스</li>
              </ol>
            </li>
            <li>
              ② 회원은 관계법, 이 약관의 규정, 이용안내 및 "서비스"와 관련하여 공지한 주의사항, (주)어셈브릭스가 통지하는 사항 등을 준수하여야 하며, 기타 (주)어셈브릭스의 업무에 방해되는 행위를 하여서는 안 됩니다.
            </li>
            <li>
              ③ (주)어셈브릭스는 재화의 품절 또는 기술적 사양의 변경 등의 경우에는 장차 체결되는 계약에 의해 제공할 재화, 용역의 내용을 변경할 수 있습니다. 이 경우에는 변경된 재화, 용역의 제공일자를 명시하여 현재의 재화, 내용을 게시한 곳에 그 제공일자 이전 7일부터 공지합니다.
            </li>
            <li>
              ④ (주)어셈브릭스가 제공하기로 이용자와 이미 계약을 체결한 서비스의 내용을 재화의 품절 또는 기술적인 사유로 변경할 경우에는 (주)어셈브릭스는 이로 인하여 이용자가 입은 손해를 배상합니다. 단, (주)어셈브릭스의 고의 또는 과실이 없는 경우에는 그러하지 아니합니다.
            </li>
            <li>
              ⑤ (주)어셈브릭스는 제1항의 서비스 중 일부에 대한 서비스 이용시간을 별도로 정할 수 있으며, 이 경우 그 이용시간을 사전에 이용자에게 공지 또는 통지합니다.
            </li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">제13조 ( 서비스의 중단 ) </h6>
        <p>
          <ul>
            <li>
              ① (주)어셈브릭스는 다음 각호에 해당하는 경우 서비스의 제공을 일시적으로 중단할 수 있습니다.
              <ol>
                <li>
                  (주)어셈브릭스가 사전에 이용자에게 공지하거나 통지한 경우
                </li>
                <li>
                  컴퓨터 등 정보통신설비의 보수점검 교체 및 고장, 통신의 두절 등의 경우
                </li>
                <li>이용자의 서비스 이용 폭주 등으로 서비스 제공이 불가능한 경우</li>
                <li>설비 등을 긴급복구 하여야 할 경우</li>
                <li>기간통신사업자가 전기통신서비스를 중지한 경우</li>
                <li>기타 (주)어셈브릭스가 합리적으로 제어할 수 없는 경우 등</li>
              </ol>
            </li>
            <li>
              ② (주)어셈브릭스는 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상합니다. 단 (주)어셈브릭스의 고의 또는 과실이 없는 경우에는 그러하지 아니합니다.
            </li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">제14조 ( 서비스의 변경 ) </h6>
        <p>
          <ul>
            <li>
              ① (주)어셈브릭스는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 "서비스"를 변경할 수 있습니다.
            </li>
            <li>
              ② "서비스"의 내용, 이용방법, 이용시간에 대하여 변경이 있는 경우에는 변경사유, 변경될 서비스의 내용 및 제공일자 등은 그 변경 전에 해당 서비스 초기화면에 게시하여야 합니다.
            </li>
            <li>
              ③ (주)어셈브릭스는 무료로 제공되는 서비스의 일부 또는 전부를 회사의 정책 및 운영의 필요상 수정, 중단, 변경할 수 있으며, 이에 대하여 관련법에 특별한 규정이 없는 한 회원에게 별도의 보상을 하지 않습니다.
            </li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">제15조 ( 서비스 이용/이용대금 ) </h6>
        <p>
          <ul>
            <li>
              ① 이용자가 서비스를 이용하기 위해서는 (주)어셈브릭스가 공지사항에 게시하거나 해당서비스 이용안내에서 제시하는 절차를 준수하여야 하며, 해당 서비스의 내용 및 책임한계 또한 공지사항에 게시된 내용 및 해당 서비스 이용안내에 따릅니다. 서비스이용신청은 반드시 실명으로 하여야 합니다.
            </li>
            <li>
              ② 서비스 이용대금은 (주)어셈브릭스가 공지사항에 게시하거나 해당 서비스 이용안내에서 제시하는 바에 따릅니다. (주)어셈브릭스가 제공하는 서비스는 그 이용대금을 별도 게시하거나 제시하지 않는 한 무료로 합니다.
            </li>
            <li>
              ③ (주)어셈브릭스는 이용자가 구매신청한 재화 또는 용역이 품절 등의 사유로 재화의 인도 또는 용역의 제공을 할 수 없을 때에는 지체 없이 그 사유를 이용자에게 통지하고, 사전에 재화 또는 용역의 대금을 받은 경우에는 그 사유발생일로부터 3일 이내에 계약해제 및 환급절차를 취합니다. 이 경우 계약해제 및 환급에는 별도의 위약금이 발생하지 않습니다.
            </li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">제16조 ( 표시착오가 있는 경우 처리 ) </h6>
        <p>
          (주)어셈브릭스는 “탑탑”을 통해 제공하는 서비스 정보는 정확성을 원칙으로 합니다. 
          다만, 제공하는 화물자동차 운송 허가증 및 운송주선사업 허가증 매매정보 및 가격정보 중 (주)어셈브릭스의 과실로 실제 가격보다 낮은 가격으로 가격이 제시되었고, 해당 가격을 확인하고 매매대금 전액을 입금한 경우, (주)어셈브릭스가 가격을 제시하는데 중대한 과실이 없는 한 동 계약은 취소할 수 있고, 서비스이용자는 이에 대해 이의를 제기하지 못합니다. 
          또한 (주)어셈브릭스는 서비스 이용자가 구매를 위해 실행한 대출 및 보험 등에 대해 책임지지 않습니다.
        </p>

        <h6 className="terms_sub_heading">제17조 ( 연결 웹사이트와 피연결 웹사이트간의 관계 ) </h6>
        <p>
          <ul>
            <li>
              ① “탑탑”과 하위 "웹사이트"가 하이퍼 링크(예: 하이퍼 링크의 대상에는 문자, 그림 및 동화상 등이 포함됨)방식 등으로 연결된 경우, 전자를 연결 웹사이트라고 하고 후자를 피연결 웹사이트라고 합니다.
            </li>
            <li>
              ② 연결 웹사이트는 피연결 웹사이트가 독자적으로 제공하는 재화 용역에 의하여 이용자와 행하는 거래에 대해서 보증책임을 지지 않는다는 뜻을 연결웹사이트의 사이트에서 명시한 경우에는 그 거래에 대한 보증책임을 지지 않습니다.
            </li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">제18조 ( 저작권의 귀속 및 이용제한 ) </h6>
        <p>
          <ul>
          <li>
            ① (주)어셈브릭스가 작성한 저작물에 대한 저작권 기타 지적재산권은 (주)어셈브릭스에 귀속합니다.
          </li>
          <li>
            ② 이용자는 “탑탑”을 이용함으로써 얻은 정보를 (주)어셈브릭스의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안됩니다.
          </li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">제19조 ( 분쟁처리 및 분쟁조정 ) </h6>
        <p>
          <ul>
            <li>
              ① (주)어셈브릭스는 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 최선을 다합니다.
            </li>
            <li>
              ② (주)어셈브릭스는 이용자로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리일정을 즉시 통보합니다.
            </li>
            <li>
              ③ (주)어셈브릭스와 이용자간에 발생한 분쟁은 “전자거래기본법” 제28조 및 동 시행령 제15조에 의하여 설치된 전자거래분쟁조정위원회의 조정에 따를 수 있습니다.
            </li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">제20조 ( 재판권 및 준거법 ) </h6>
        <p>
          <ul>
            <li>
              ① (주)어셈브릭스와 이용자간에 발생한 분쟁에 관한 소송은 민사소송법상의 관할법원에 제기합니다. 다만, 서비스 이용시 관할법원에 대한 별도 합의가 있는 경우에는 이에 따릅니다.
            </li>
            <li>
              ② (주)어셈브릭스와 이용자간에 제기된 소송에는 한국법을 적용합니다.
            </li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">제21조 ( 데이터 베이스의 보호 ) </h6>
        <p>
          <ul>
            <li>
              ① (주)어셈브릭스는 서비스를 이용하여 구축되는 데이터 베이스에 대하여 robots.txt 파일 등의 소정의 저작권 보호 장치로써 이를 보호하고 있습니다. 보호되고 있는 데이터베이스를 타 검색 로봇이 수집하는 것을 불허 합니다.
            </li>
            <li>
              ② (주)어셈브릭스의 데이터 베이스를 계속 수집하는 경우
              <li>&nbsp;&nbsp; - (주)어셈브릭스의 고유한 서비스 정보가 유출될 수 있습니다.</li>
              <li>&nbsp;&nbsp; - (주)어셈브릭스 서비스의 게시물이나 창작물이 게시자의 의사에 반하여 다른 곳에서 보여지고 원하지 않는 방향으로 이용될 수 있습니다.</li>
              <li>&nbsp;&nbsp; - (주)어셈브릭스 서비스 내에서 비공개로 작성되거나 삭제된 게시물이 작성자의 의사에 반하여 공개되거나 지속적으로 게시 유포될 수 있습니다.</li>
            </li>
            <li>
              ③ (주)어셈브릭스의 데이터베이스를 수집해가는 행위는 고의성의 여부를 불문하고 국제적인 인터넷 검색 서비스와 개인 정보 보호를 위한 규칙에 어긋나는 것이며, 2번 항목과 같은 문제와 피해 사항들이 발생할 위험이 크고, 경우에 따라 저작권 침해 또는 정보통신망 이용촉진및 정보보호에 관한 법률 등에 위반될 수 있습니다.
            </li>
          </ul><br/>
          (주)어셈브릭스의 데이터베이스에 설치된 소정의 저작권 보호 장치 및 관련 규정을 무시하고 계속 데이터를 수집할 경우, (주)어셈브릭스의 서버와 데이터보호뿐 아니라 저작권 보호를 위해 (주)어셈브릭스는 해당 행위에 대하여 법적 절차를 포함하여 엄중한 책임을 물을 것입니다.
        </p>

        <h6 className="terms_sub_heading">제22조 ( (주)어셈브릭스 서비스 이용에 따른 주의사항  ) </h6>
        <p>
          <ul>
            <li>
              ① (주)어셈브릭스의 사전 허락 없이 자동화된 수단(예: 매크로 프로그램, 로봇(봇), 스파이더, 스크래퍼 등)을 이용하여 타 서비스((주)어셈브릭스가 직접 운영하는 홈페이지, 어플리케이션 이외의 다른 홈페이지, 어플리케이션 등 형태를 불문한 일체의 온라인 서비스)에 (주)어셈브릭스가 직접 운영하는 홈페이지 및 어플리케이션에 게시된 내용(화물운송사업 허가증 및 운송주선사업 허가증의 가격, 지역, 관련 정보, 기타 부가 서비스 내용 등 모든 서비스 정보 일체)을 무단으로 게재하는 등 정확한 정보를 제공하고자 하는 “탑탑” 서비스의 취지에 부합하지 않는 방식으로 (주)어셈브릭스의 서비스 정보를 이용하거나, 이와 같은 (주)어셈브릭스 서비스 정보의 어뷰징(남용)행위를 막기위한 (주)어셈브릭스의 기술적 조치를 무력화하려는 일체의 행위(예: IP를 지속적으로 바꿔가며 접속하는 행위, 외부 솔루션을 통한 Captcha 우회 등)를 시도해서는 안됩니다.
            </li>
          </ul>
        </p>

        <h6 className="terms_sub_heading">부칙</h6>
        <p>가. 제1조 (시행일) 이 약관은 2025년 04월 15일부터 시행합니다.</p>
      </div>
    </>
  );
};
export default TermsOfUse;
